import { render, staticRenderFns } from "./NotesModal.vue?vue&type=template&id=643a0d68&scoped=true&"
import script from "./NotesModal.vue?vue&type=script&lang=js&"
export * from "./NotesModal.vue?vue&type=script&lang=js&"
import style0 from "./NotesModal.vue?vue&type=style&index=0&id=643a0d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a0d68",
  null
  
)

export default component.exports